<template>
    <modal-wrapper modalClass="modal--small" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h3>Openingstijd toevoegen</h3>
        </div>
        <div class="modal__content">
            <div class="row" style="margin: 2.4rem 0;">
                <form>
                    <div class="col-12">
                        <div class="form__group">
                            <label class="form__label">Dag</label>
                            <div class="select">
                                <select v-model="time.day">
                                    <option v-for="day in getDays()" :value="getDays().indexOf(day) + 1">{{day}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form__group">
                            <label class="form__label">Openingstijd</label>
                            <input type="text" class="form__input--text" v-model="time.open" placeholder="00:00"/>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form__group">
                            <label class="form__label">Sluittijd</label>
                            <input  v-validate="'required|numeric'"
                                    :class="{'form__input--text': true, 'has-error': errors.has('closingTime') }"
                                   type="text" name="closingTime"
                                    id="closingTime"
                                   v-model="time.close"
                                   placeholder="00:00"/>
                            <div v-show="errors.has('closingTime')">ERRORRRR</div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="modal__footer">
            <button class="button--cta" type="submit" @click="save">Opslaan</button>
            <button class="button--alt" type="button" @click="$modal.hide(name)">Annuleer</button>
        </div>

        <div class="loading" v-if="loading">
            <div class="spinner" style="top: 40%;"></div>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import {getDayLong, getDaysLong} from '@/utils';
    import { Validator } from 'vee-validate';
    @Component
    export default class AddTimeModal extends Vue {
        name = 'add-time-modal';

        time = {};

        loading = false;

        created() {
            this.$validator.attach('closingTime', [
                { name: 'required' },
                { name: 'regex', params: /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/g }
            ]);
        }

        save() {
            this.loading = true;
//            this.$emit('save', this.time);
            this.validate();
        }

        getDay(day) {
            return getDayLong(day);
        }

        getDays() {
            return getDaysLong();
        }

        beforeOpen(event) {
            var time = event.params.time;
            this.loading = false;
            this.time = (!time || time === undefined) ? {} : time;
        }

        validate() {
            console.log('Validate', 'Start', this.$validator);
//            this.$validator.validate('closingTime', this.time.closing);
//            if (this.$validator.errors.has('closingTime')) {
//                return;
//            }

            this.$validator.validateAll().then((result) => {
                if (result) {
                    // eslint-disable-next-line
                    alert('From Submitted!');

                    this.$emit('save', this.time);
                    return;
                }

                alert('Correct them errors!');
            });
        }
    }

    Vue.component(AddTimeModal.name, AddTimeModal);
</script>



// WEBPACK FOOTER //
// src/pages/market/modals/AddTimeModal.vue